import PropTypes from 'prop-types';

// These are prop types specific to UDS TextInput; see also ../utils/props/textInputProps
// for generic React Native props and HTML input attrs that are passed through.
const textInputPropTypes = {
  /**
   * If the input's state is to be controlled by a parent component, use this prop
   * together with the `onChange` to pass down and update the lifted state.
   */
  value: PropTypes.string,
  /**
   * Use this to set the type of the input. Defaults to `text`.
   */
  type: PropTypes.string,
  /**
   * Use this to set the initial value of an uncontrolled input.
   * Updating `initialValue` will **not** update the actual value.
   */
  initialValue: PropTypes.string,
  /**
   * Disables all user interactions with the input.
   */
  inactive: PropTypes.bool,
  /**
   * Makes it impossible to change the input's value.
   */
  readOnly: PropTypes.bool,
  /**
   * Use to react upon input's value changes. Required when the `value` prop is set.
   * Will receive the input's value as an argument.
   */
  onChange: PropTypes.func
};
export default textInputPropTypes;